import React from 'react';
import type { ChildrenProp, ClassNameProp } from '../common-types';
import type { ButtonProps } from './Button';

/**
 * Defines the link properties
 *
 */
export interface LinkProps
  extends ClassNameProp,
    ChildrenProp,
    Partial<Pick<ButtonProps, 'variant' | 'scale'>> {
  /** Determines if the Link is disabled or not. Default to false */
  disabled?: boolean;

  /** The link target. */
  href: string;
}

/**
 * The link itself.
 * @param disabled Determines if the Link is disabled or not. Default to false
 * @param className the additional class names.
 * @param href the link target
 * @param variant the button variant.
 * @param children node inside the link.
 * @param scale the button scale.
 * @param props leftover props
 * @constructor
 */
export function Link({
  disabled = false,
  className,
  href,
  variant = 'gray',
  children,
  scale = 'default',
  ...props
}: Readonly<LinkProps>): React.JSX.Element {
  const cName = `ehs-link button-${variant} button-${scale} ${
    className ?? ''
  }`.trim();
  if (disabled) {
    return (
      <span {...props} className={'disabled ' + cName}>
        {children}{' '}
      </span>
    );
  } else {
    return (
      <a {...props} className={cName} href={href}>
        {children}
      </a>
    );
  }
}
